import { token } from '@atlaskit/tokens';
import { Box, Stack, Text } from '@atlaskit/primitives';

export default function AccessDeniedPage() {
  return (
    <Box
      style={{
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'center',
        minHeight: 'calc(100vh - 160px)',
        padding: token('space.400')
      }}
    >
      <Box
        style={{
          background: token('elevation.surface.overlay'),
          border: `1px solid ${token('color.border')}`,
          borderRadius: '24px',
          boxShadow: token('elevation.shadow.raised'),
          maxWidth: '560px',
          padding: token('space.500'),
          textAlign: 'center',
          width: '100%'
        }}
      >
        <Stack space="space.200" alignBlock="center">
          <Text weight="bold" size="large">
            You do not have access
          </Text>
          <Text color="color.text.subtle">
            Please contact the team for more information.
          </Text>
        </Stack>
      </Box>
    </Box>
  );
}
